import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

import { OrcamentoSintetico } from '../../models/orcamentos/orcamento-sintetico';

export interface OrcamentosPagedRequest {
  id?: string;
  page: number;
  pageSize: number;
  sort?: string;
  direction?: string;
  dataInicio?: string;
  dataFim?: string;
  cliente?: string;
  nroPedido?: number;
  status?: string;
  vendedor?: string;
}

export interface PagedResult<T> {
  items: T[];
  total: number;
  page: number;
  pageSize: number;
}

export interface OrcamentoStatsResult {
  qtdePedidos: number;
  valorVendas: number;
  litragemTotal: number;
  statusStats: { status_pedido: string; valor: number; litragem: number; quantidade: number }[];
}

@Injectable({
  providedIn: 'root'
})

export class OrcamentoService {
  private baseUrl: string;
  private headers = new HttpHeaders();

  constructor(
    private http: HttpClient,
    @Inject("BASE_URL") baseUrl: string,
    private toastr: ToastrService
  ) {
    this.baseUrl = baseUrl;
  }

  /* Sintético */

  public getByUsuario(): Observable<OrcamentoSintetico[]> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "id": localStorage.getItem("id")
    };

    return this.http.post<OrcamentoSintetico[]>(this.baseUrl + "api/Orcamento/GetByUsuario", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of([]);
      })
    );
  }

  public getPendenciasByUsuario(): Observable<OrcamentoSintetico[]> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "id": localStorage.getItem("id")
    };

    return this.http.post<OrcamentoSintetico[]>(this.baseUrl + "api/Orcamento/GetPendenciasByUsuario", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of([]);
      })
    );
  }

  /* Sintético — Paginação */

  public getNaoEnviadosPaged(req: OrcamentosPagedRequest): Observable<PagedResult<OrcamentoSintetico>> {
    this.headers.set('Content-Type', 'application/json');
    const data = { ...req, id: req.id != null ? req.id : localStorage.getItem('id') };
    return this.http.post<PagedResult<OrcamentoSintetico>>(this.baseUrl + 'api/Orcamento/ListNaoEnviadosPaged', data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error('', 'Houve um erro, contate o suporte...');
        return of({ items: [], total: 0, page: req.page, pageSize: req.pageSize });
      })
    );
  }

  public getStatsNaoEnviados(req: OrcamentosPagedRequest): Observable<OrcamentoStatsResult> {
    this.headers.set('Content-Type', 'application/json');
    const data = { ...req, id: req.id != null ? req.id : localStorage.getItem('id') };
    return this.http.post<OrcamentoStatsResult>(this.baseUrl + 'api/Orcamento/StatsNaoEnviados', data, { headers: this.headers }).pipe(
      catchError(() => of(null))
    );
  }

  public getPendenciasPaged(req: OrcamentosPagedRequest): Observable<PagedResult<OrcamentoSintetico>> {
    this.headers.set('Content-Type', 'application/json');
    const data = { ...req, id: req.id != null ? req.id : localStorage.getItem('id') };
    return this.http.post<PagedResult<OrcamentoSintetico>>(this.baseUrl + 'api/Orcamento/ListPendenciasPaged', data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error('', 'Houve um erro, contate o suporte...');
        return of({ items: [], total: 0, page: req.page, pageSize: req.pageSize });
      })
    );
  }

  public getStatsPendencias(req: OrcamentosPagedRequest): Observable<OrcamentoStatsResult> {
    this.headers.set('Content-Type', 'application/json');
    const data = { ...req, id: req.id != null ? req.id : localStorage.getItem('id') };
    return this.http.post<OrcamentoStatsResult>(this.baseUrl + 'api/Orcamento/StatsPendencias', data, { headers: this.headers }).pipe(
      catchError(() => of(null))
    );
  }

  /* Ações */

  public alterar(id: number, seller_id: number): Observable<boolean> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "id": id,
      "seller_id": seller_id
    };

    return this.http.post<boolean>(this.baseUrl + "api/Orcamento/Alterar", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(false);
      })
    );
  }

  public desativar(id: number, seller_id: number): Observable<boolean> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "id": id,
      "seller_id": seller_id
    };

    return this.http.post<boolean>(this.baseUrl + "api/Orcamento/Desativar", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(false);
      })
    );
  }

  public enviar(id: number, seller_id: number): Observable<boolean> {
    this.headers.set("Content-Type", "application/json");

    let data = {
      "id": id,
      "seller_id": seller_id
    };

    return this.http.post<boolean>(this.baseUrl + "api/Orcamento/Enviar", data, { headers: this.headers }).pipe(
      catchError(() => {
        this.toastr.error("", "Houve um erro, contate o suporte...");

        return of(false);
      })
    );
  }
}
